import { getUserInfo } from '@/api/index'

const state = {
  userInfo: {},
  login: false,
  isOff: false
}
const mutations = {
  SET_USER_INFO(state, data) {
    state.userInfo = data
  },
  SET_AUDIO(state, data) {
    state.isOff = data
  },
}
const actions = {
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getUserInfo().then(res => {
        commit('SET_USER_INFO', res.data)
        resolve(res)
      })
    })
  },
  setAudio({ commit }, data) {
    commit('SET_AUDIO', data)
  }

}
export default {
  state,
  mutations,
  actions
}
